import { deleteTasks } from './_store';

export default function smsSendTaskDelete(options) {
  let body = {};
  try {
    body = JSON.parse(options?.body || '{}');
  } catch (e) {
    body = {};
  }

  const deletedCount = deleteTasks(body.ids);

  return {
    code: 2001,
    data: deletedCount,
    message: 'success',
  };
}

